module.exports = __webpack_public_path__ + "img/alert.408dcf92.svg";